var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExchangeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C5.165 0 1.963 2.37.656 5.719l1.383.562C3.132 3.481 5.783 1.5 9 1.5c2.432 0 4.6 1.192 5.953 3H12V6h5.25V.75h-1.5v2.32A8.953 8.953 0 0 0 9 0Zm6.96 11.719C14.869 14.519 12.218 16.5 9 16.5c-2.458 0-4.617-1.21-5.977-3H6V12H.75v5.25h1.5v-2.32C3.89 16.79 6.296 18 9 18c3.835 0 7.037-2.37 8.344-5.719l-1.383-.562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchangeCircle);
export default ForwardRef;